import React, { useCallback } from 'react';
import { TabId } from '../types';
import { useHaptic } from '../hooks/useHaptic';

const TABS: { id: TabId; label: string; icon: string }[] = [
  { id: 'threshold', label: 'Threshold', icon: '◉' },
  { id: 'write', label: 'Write', icon: '✍' },
  { id: 'chat', label: 'Chat', icon: '☰' },
  { id: 'memory', label: 'Memory', icon: '✦' },
];

interface NavigationProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
}

export const Navigation: React.FC<NavigationProps> = React.memo(
  function Navigation({ activeTab, onTabChange }) {
    const { trigger } = useHaptic();

    const handle = useCallback(
      (tab: TabId) => {
        trigger('light');
        onTabChange(tab);
      },
      [onTabChange, trigger]
    );

    return (
      <nav className="bottom-nav" role="navigation" aria-label="Main navigation">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`bottom-nav-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => handle(tab.id)}
            aria-label={tab.label}
            aria-current={activeTab === tab.id ? 'page' : undefined}
          >
            <span className="bottom-nav-icon" aria-hidden="true">
              {tab.icon}
            </span>
            <span className="bottom-nav-label">{tab.label}</span>
          </button>
        ))}
      </nav>
    );
  }
);

export default Navigation;
